import { CorpUIResponse, SSOIdentifierEnum } from 'src/types/Corp';
import { CSV_TEMPLATE_CONFIG } from 'src/components/enterprise/features/Employee/EmployeeUploadPage/components/DownloadCsvTemplate/constants';

export function isSsoIdentifierOther(corpData: CorpUIResponse): boolean {
  return (
    !!corpData?.ssoEnabled &&
    corpData?.ssoIdentifier === SSOIdentifierEnum.OTHER
  );
}

export function getCsvTemplateAssetName(corpData: CorpUIResponse): string {
  return isSsoIdentifierOther(corpData)
    ? CSV_TEMPLATE_CONFIG.ssoIdentifierOther.assetName
    : CSV_TEMPLATE_CONFIG.default.assetName;
}

export function getCsvTemplateDownloadName(corpData: CorpUIResponse): string {
  return isSsoIdentifierOther(corpData)
    ? CSV_TEMPLATE_CONFIG.ssoIdentifierOther.downloadName
    : CSV_TEMPLATE_CONFIG.default.downloadName;
}
